export default __webpack_public_path__ + "static/media/advantage-1.ca992e0b.png";